import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { hasAllPermissions, hasPermission, useTableFilter } from '@/shared';
import { useFetchTypeRegimens, useUpdateTypeRegimenes } from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { TYPERegimens } from '@/shared/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';
import { PermissionsEnum } from '@/auth/interfaces';

const returnUrl = '/parametrizacion/tipo-regimenes';
export interface TypeRegimenesInterface { }
const TypeRegimenesPage: React.FC<TypeRegimenesInterface> = () => {
  const navigate = useNavigate();
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,

  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* fetch data
  const {
    data: typeRegimenPagingRes,
    isLoading,
    isRefetching,
    refetch,
  } = useFetchTypeRegimens({
    page: pageIndex + 1,
    nombre: searchTerm,
  });

  ///* handlers
  const onEdit = (original: TYPERegimens) => {
    navigate(`${returnUrl}/editar/${original.id_tipo_regimen}`);
  };
  const updState = useUpdateTypeRegimenes({
    enableRedirect: false,
    onSuccess: () => refetch(),
  })
  ///* columns
  const columns = useMemo<MRT_ColumnDef<TYPERegimens>[]>(
    () => [
      /* {
        accessorKey: 'codigo',
        header: 'Codigo',
        size: 100,
      }, */
      {
        accessorKey: 'numero_referencia',
        header: 'Numero de referencia',
        size: 100,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <SwitchComponente
              estadoSwitch={row.original.estado}
              titulo={row.original.estado ? 'Activo' : 'Inactivo'}
              setEstadoSwitch={state => {
                if (!hasPermission(PermissionsEnum.api_change_tiporegimen)) return;
                setConfirmDialog({
                  isOpen: true,
                  title: 'Cambiar Estado',
                  subtitle:
                    '¿Está seguro que desea cambiar el estado de este registro ?',
                  onConfirm: async () => {
                    setConfirmDialogIsOpen(false);
                    updState.mutate({
                      id: row.original.id_tipo_regimen!,
                      data: { estado: !!state } as any,
                    });
                  },
                });
              }}
            />
          );
        },
      },
    ],
    []
  );
  return (
    <SingleTableBoxScene title="Tipos de regímenes" urlRedirect={`${returnUrl}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_tiporegimen)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="tipo de regimenes" />

      <GeneralTable<TYPERegimens>
        columns={columns}
        data={typeRegimenPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={typeRegimenPagingRes?.data?.count}
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_tiporegimen,
        ])}
        // // actions
        actionsColumnSize={120}
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_tiporegimen,
        ])}
        // crud
        onEdit={onEdit}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default TypeRegimenesPage;